<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      עריכת פרופיל רופא &nbsp;
      <span class="fw-regular"> {{ profileDescr }}</span>
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="body-container t-scrollbar">
  <div class="wizard">
    <ng-container *ngFor="let step of steps; let i = index">
      <ng-container
        *ngTemplateOutlet="stepTemplate; context: { $implicit: steps[i] }"
      ></ng-container>

      <ng-container *ngIf="i !== steps.length - 1">
        <ng-container
          *ngTemplateOutlet="
            arrowTemplate;
            context: { $implicit: isPast(steps[i]) }
          "
        ></ng-container
      ></ng-container>
    </ng-container>
  </div>

  <div class="content t-scrollbar">
    <edit-profile-rx
      *ngIf="curStep?.stepCode == 'RX_OPT_FIXED'"
      [lineType]="'FIXED'"
      [profile]="data"
    ></edit-profile-rx>

    <edit-profile-rx
      *ngIf="curStep?.stepCode == 'RX_OPT_REMOVABLE'"
      [lineType]="'REMOVABLE'"
      [profile]="data"
    ></edit-profile-rx>

    <edit-profile-auto-approve
      *ngIf="curStep?.stepCode == 'AUTO_APPROVE'"
      [profile]="data"
    >
    </edit-profile-auto-approve>

    <edit-profile-pg
      *ngIf="curStep?.stepCode == 'PERSONAL_GUIDANCE'"
      [profile]="data"
    ></edit-profile-pg>

    <edit-profile-notes
      *ngIf="curStep?.stepCode == 'NOTE'"
      [profile]="data"
    ></edit-profile-notes>

    <edit-profile-sign *ngIf="curStep?.stepCode == 'SIGN'" [profile]="data">
    </edit-profile-sign>
  </div>
</div>

<div class="footer l-align-spaceBetween">
  <button
    [class.hidden]="curStep.stepId == 1"
    (click)="back()"
    class="t-button-outline"
  >
    חזרה
  </button>

  <button
    *ngIf="curStep.stepId != steps.length"
    (click)="next()"
    class="t-button--success"
  >
    המשך
  </button>

  <button
    *ngIf="curStep.stepId == steps.length"
    (click)="save()"
    class="t-button--success"
  >
    שמירה
  </button>
</div>

<ng-template #stepTemplate let-step>
  <div
    class="step-container"
    [class.cur]="isCur(step)"
    [class.past]="isPast(step)"
    [class.future]="isFuture(step)"
  >
    <div class="step">
      {{ step.stepId }}
    </div>

    <p class="step-descr">{{ step.text }}</p>
  </div>
</ng-template>

<ng-template #arrowTemplate let-past>
  <div class="arrow-container">
    <img
      class="arrow"
      [src]="
        past
          ? 'assets\\img\\tracker\\angle-left.svg'
          : 'assets\\img\\tracker\\angle-left-grey.svg'
      "
    />
    <div class="line" [class.past]="past" [class.future]="!past"></div>
  </div>
</ng-template>
